<template>
  <div class="wrapper">
    <!-- <div class="content">
      <h1>Nueva llave</h1>
    </div>-->
    <section class="content alineacion">
       <form @submit="addRotation($event)">
        <div class="form-row">
          <div class="form-group col-md-12 weekDays-selector">
            <p>{{$t('daysOfShift')}}</p>
            <input type="checkbox" id="weekday-mon" class="weekday" v-model="shift.days[0]" @change="validateFields()"/>
            <label for="weekday-mon">{{$t('shiftDay1')}}</label>
            <input type="checkbox" id="weekday-tue" class="weekday" v-model="shift.days[1]" @change="validateFields()"/>
            <label for="weekday-tue">{{$t('shiftDay2')}}</label>
            <input type="checkbox" id="weekday-wed" class="weekday" v-model="shift.days[2]" @change="validateFields()"/>
            <label for="weekday-wed">{{$t('shiftDay3')}}</label>
            <input type="checkbox" id="weekday-thu" class="weekday" v-model="shift.days[3]" @change="validateFields()"/>
            <label for="weekday-thu">{{$t('shiftDay4')}}</label>
            <input type="checkbox" id="weekday-fri" class="weekday" v-model="shift.days[4]" @change="validateFields()"/>
            <label for="weekday-fri">{{$t('shiftDay5')}}</label>
            <input type="checkbox" id="weekday-sat" class="weekday" v-model="shift.days[5]" @change="validateFields()"/>
            <label for="weekday-sat">{{$t('shiftDay6')}}</label>
            <input type="checkbox" id="weekday-sun" class="weekday" v-model="shift.days[6]" @change="validateFields()"/>
            <label for="weekday-sun">{{$t('shiftDay7')}}</label>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <!-- <HotelDatePicker format="DD/MM/YYYY" :startDate="getDateToStart()" [v-model]="newKey.notBefore" ></HotelDatePicker> -->
            <label for="inputAddress">{{$t('shiftInitTime')}}</label>
            <input
              type="time"
              v-model="shift.time.initHour"
              class="form-control"
              id="inputAddress"
              @change="validateFields()"
              required
            />
          </div>
          <div class="form-group col-md-6">
            <label for="inputAddress2">{{$t('shiftFinishTime')}}</label>
            <input
              type="time"
              v-model="shift.time.finishHour"
              class="form-control"
              id="inputAddress2"
              @change="validateFields()"
              required
            />
          </div>
        </div>
        <!-- <label for="split-shift">{{$t('isSplitShift')}}</label>
        <div class="form-row" v-if="splitShift">
          <div class="form-group col-md-6"> -->
            <!-- <HotelDatePicker format="DD/MM/YYYY" :startDate="getDateToStart()" [v-model]="newKey.notBefore" ></HotelDatePicker> -->
            <!-- <label for="inputAddress">{{$t('shiftInitTime')}}</label>
            <input
              type="time"
              v-model="shift.time2.initHour"
              class="form-control"
              id="inputAddress"
              @change="validateFields()"
              required
            />
          </div>
          <div class="form-group col-md-6">
            <label for="inputAddress2">{{$t('shiftFinishTime')}}</label>
            <input
              type="time"
              v-model="shift.time2.finishHour"
              class="form-control"
              id="inputAddress2"
              @change="validateFields()"
              required
            />
          </div>
        </div> -->
        <div class="form-row">
          <div class="form-group offset-md-3 col-md-6">
            <label for="inputState">{{$t('keySelectLock')}}</label>
            <select id="inputState" class="form-control" v-model="room" @change="validateFields()">
              <option disabled value>{{$t('keySelection')}}</option>
              <option v-for=" lock in datosLocker" :key="lock.lastUpdate">{{lock.brief_desc}}</option>
            </select>
          </div>
        </div>
          <button type="submit" class="btn btn-primary" :disabled="!isCheckedField  || (splitShift&&!isCheckedField2)">{{ $t('dashboardAddShift') }} <img v-if="!isCheckedField || (splitShift&&!isCheckedField2)" src="https://shots.jotform.com/jan/images/lock-icon.png" alt="Locker Image"> </button>
          <!-- <button type="submit" class="btn btn-primary">Give Access</button> -->
      </form>
    </section>
  </div>
</template>

<script>
/* import btoa from "btoa"; */
import _ from "lodash";
import HotelDatePicker from "vue-hotel-datepicker";
import i18n from '@/plugins/i18n';

export default {
  data() {
    return {
      shift:{
        days:[],
        time:{
          initHour:"",
          finishHour:""
        },
        time2:{
          initHour:"",
          finishHour:""
        }
      },
      splitShift:false,
      reader:{},
      datosLocker: [],
      room:"",
      isCheckedField:false,
      isCheckedField2:false,
      language:localStorage.getItem('language'),
      language_user:"",
      languages_user: [{ 
                    flag: 'gb', 
                    language: 'en', 
                    title: 'English' 
                  },
                  { flag: 'es', 
                    language: 'es', 
                    title: 'Español' },
                  { flag: 'de',
                    language: 'de',
                    title: 'Deutsch'}]
    };
  },
  methods: {
    lockersAvailable() {
      // console.log("Entra por aquí");
      var login = JSON.parse(localStorage.getItem("session"));
      console.log(localStorage.getItem("user_email"));
      this.axios
        .post("https://lightkey.es:3000/lightime/api/readers",
         {
           email:localStorage.getItem("user_email")
         },
         {
          headers: { authorization: login.session }
        })
        .then(response => {
          // console.log("respuesta de locks disponibles", response.data);
          response.data.forEach(dato => {
            console.log("Cada dato", dato);
            this.datosLocker.push(dato);
          });
          console.log(this.datosLocker);

          /* 
          console.log("Array rooms", this.datosLocker);
          this.rooms = this.datosLocker.map(room => room.brief_desc);
          console.log("Rooms", this.rooms); */
        })
        .catch(err => {
          console.error("Ocurrio un error cargando usuarios", err);
          this.$router.replace("/");
        });
    },
    isSplitShift(){
      console.log("Split",this.splitShift);
      if(!this.splitShift){
        this.splitShift=true;
        console.log("Split",this.splitShift);
      }else{
        this.splitShift=false;
      }  
    },
    addRotation(event){
      var days_of_week=[];
      this.shift.days.forEach((clave,valor)=>{
        console.log("clave ", clave);
        console.log("valor ", valor);
        if(_.isEmpty(clave)){
          switch (valor){
            case 0:
              days_of_week.push("Monday");
              break;
            case 1:
              days_of_week.push("Tuesday");
              break;
            case 2:
              days_of_week.push("Wednesday");
              break;
            case 3:
              days_of_week.push("Thursday");
              break;
            case 4:
              days_of_week.push("Friday");
              break;
            case 5:
              days_of_week.push("Saturday");
              break;
            case 6:
              days_of_week.push("Sunday");
              break;
          }
        }
      });
      console.log(days_of_week);
      this.shift.days=days_of_week;
      console.log("Turno ",this.shift);
      this.reader=this.datosLocker.filter(lock=>lock.brief_desc==this.room);
      console.log("Lector ",this.reader);
      console.log("Room: ",this.room);
      console.log("Lectores: ",this.datosLocker);
      this.axios.post('https://lightkey.es:3000/lightime/api/rotations/',{shift:this.shift,reader:this.reader})
      .then(response=>{
        console.log(response);
        switch(i18n.locale){
          case "en":
            this.$toastr.s(i18n.messages.en.addShiftComplete);
            break;
          case "es":
            this.$toastr.s(i18n.messages.es.addShiftComplete);
            break;
          case "de":
            this.$toastr.s(i18n.messages.de.addShiftComplete);
            break;  
        }
        this.$router.replace("/dashboard/view-users");
      })
      .catch(error=>console.log(error))      
    },
    validateFields(){
      console.log(this.shift);
      var init=this.shift.time.initHour.split(":")
      var inHo=init[0];
      var inMi=init[1];

      var finish=this.shift.time.finishHour.split(":")
      var finHo=finish[0];
      var finMi=finish[1];
      //Si no ha seleccionado días
      if(!this.shift.days.find(day=>day==true)){
        console.log("No hay dias");
        this.isCheckedField=false;
      }else{
        //Si la hora de inicio es mayor o igual que la salida y en caso de que sea igual los minutos de inicio son mayores que los de salida
        if(inHo>finHo && inHo && finHo){
          this.isCheckedField=false;
        }else if(inHo<finHo && inHo && finHo){
            if(this.room){
              console.log("ROOM", this.room);
              this.isCheckedField=true;
            }         
        }else if(inHo==finHo && inHo && finHo){
          if(inMi>=finMi){
            this.isCheckedField=false;
          }else{
            this.isCheckedField=true;
          }
        }
        /*if(!_.isEmpty(this.shift.time2)){
          //console.log("Tiempo 2",this.shift);
          var init2=this.shift.time2.initHour.split(":")
          var inHo2=init2[0];
          var inMi2=init2[1];

          var finish2=this.shift.time2.finishHour.split(":")
          var finHo2=finish2[0];
          var finMi2=finish2[1];
          if(inHo2>finHo2 && inHo2 && finHo2){
            this.isCheckedField2=false;
          }else if(inHo2<finHo2 && inHo2 && finHo2 && finHo<inHo2){
            if(this.room){
              console.log("ROOM2", this.room);
              this.isCheckedField2=true;
            }           
          }else if(inHo2==finHo && inHo2 && finHo){
            if(inMi2<=finMi){
              this.isCheckedField2=false;
            }else{
              this.isCheckedField2=true;
            }
          }
        }*/
      }
      console.log("TIEMPO 1",this.isCheckedField);
      console.log("TIEMPO 2",this.isCheckedField2);
      console.log("SPLIT",this.splitShift);
    },
    setLanguage(){
      if(localStorage.getItem('language')){
        console.log(localStorage.getItem('language'));
        i18n.locale = localStorage.getItem('language');
        this.language_user=localStorage.getItem('language');
      }else{
        console.log("No hay lenaguaje");
      }
    },
    changeLocaleUser(locale) {        
      this.language_user=locale;
      console.log(this.language_user);
    },

  },
  created() {
    this.setLanguage();
    this.lockersAvailable();
  },
  watch: {},
  computed: {
    validation() {}
  },
  components: {
    HotelDatePicker
  }
};
</script>


<style >
.weekDays-selector input {
  display: none!important;
}

.weekDays-selector input[type=checkbox] + label {
  display: inline-block;
  padding:5px;
  border-radius: 6px;
  background: #dddddd;
  margin-right: 20px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}

.weekDays-selector input[type=checkbox]:checked + label {
  background: #5cb85c;
  color: #ffffff;
}

.wrapper {
  display: grid;
  grid-template-columns: 1fr 1100px 1fr;
}

.content {
  grid-column: 2/3;
}

.error {
  color: red;
}

.correct {
  color: green;
}
h1 {
  margin-top: 20px;
}

.alineacion {
  margin-top: 90px;
}

.btn {
  background-color: #5cb85c;
  color: white;
  border: 1px solid #4cae4c;
}

@media (max-width: 1160px) {
  .wrapper {
    display: grid;
    grid-template-columns: 1fr 99% 1fr;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/dashboard/children/AddShift.vue